module.exports = __webpack_public_path__ + "math.svg?944408aad8a2fc7876d84dc4915e4215";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/math.svg
// module id = 122
// module chunks = 0